'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var MAIN_NAV_CLICKED = 'main-nav-clicked:event';
var PANIC_BAR_VISIBLE = 'panic-bar-visible:event';

exports.MAIN_NAV_CLICKED = MAIN_NAV_CLICKED;
exports.PANIC_BAR_VISIBLE = PANIC_BAR_VISIBLE;
